<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), {
  color: "content-high",
  size: "md",
  background: "transparent",
});

const colorClass = computed((): string => `stroke-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 20 20">
    <rect x="0.65" y="0.65" width="18.7" height="18.7" rx="1.35" :class="colorClass" stroke-width="1.3" />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
